import { ObjectHelpers } from "../../helpers/object-helpers";
import { QuoteType } from "../trade/trade.model";

export enum DefaultRiskManagementType {
    Dollars = 'Dollars',
    Percentage = 'Percentage'
}

export class ChartSettingsPopupModel {
    public displayOrderConfirmationPopup = true;
    public displayMoneyMachineConfirmationPopup = true;
    public defaultQuoteQuantity = 1000;
    public defaultQuoteType = QuoteType.Shares;
    public useDefaultStopLoss = false;
    public defaultStopLossValue = 0;
    public defaultStopLossType = DefaultRiskManagementType.Dollars;
    public useDefaultProfitTarget = false;
    public defaultProfitTargetValue = 0;
    public defaultProfitTargetType = DefaultRiskManagementType.Dollars;
    public displayPremarket = true;
    public displayPostmarket = true;
    public displayChartSettingZoomAndScroll = true;
    public displayMainChartChangePercentVisibleCandles = false;
    public displayBrowserChartExistingBuySellButtons = false;
    public displayChartSettingBuySellFlags = true;
    public enableRightEdgePadding = true;
    public pnpBrowserChartsByDefault = true;
    public defaultEnableTradeOrderEntry = true;
    public displayNewIndicatorManager = true;
    public displayAlertsOnChart = true;
    public displayResistanceAndSupport = true;
    
    // state
    public displayAlertsOnChartPositionTop = false;

    public applyToAllCharts = false;
    public saveToDefaultCharts = false;
    
    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}